module.exports = __webpack_public_path__ + "static/media/6.90c6ed2d.jpg";